import * as React from "react"
import styled from "styled-components"
import Header from "./Header"

const Wrapper = styled.div`
  position: relative;
  width: 95%;
  margin: auto;
`
const Main = styled.main`
  flex: 1;
  overflow-x: auto;
  margin: 48px 0 20px 0;
`

const PageWrapper = ({children}) => (
  <Wrapper>
    <Header/>
    <Main>{children}</Main>
  </Wrapper>
)

export default PageWrapper
